import styled from 'styled-components';
import React, { FC } from 'react';
import { Heading, Subtitle, TrevorIcon } from '@trevor/ui-components';

const TitleAndSubtitleContainer = styled.div`
  text-align: center;

  > p {
    margin-top: 35px;
  }
`;

type TitleAndSubtitleProps = {
  showSubtitle: boolean;
};
export const TitleAndSubtitleSection: FC<TitleAndSubtitleProps> = ({
  showSubtitle,
}) => {
  return (
    <TitleAndSubtitleContainer>
      <Heading variant={1}>
        <TrevorIcon name="illustration-waving-hand" size="xl" />
        Welcome
      </Heading>
      {showSubtitle && (
        <Subtitle variant={1}>
          To get started, connect your database or try a sample database.
        </Subtitle>
      )}
    </TitleAndSubtitleContainer>
  );
};
